import React from 'react';
import { Button, Tooltip } from '@bynder/design-system';
import { IconColorPicker } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import { Color } from 'packages/ds/ColorPicker/types';
import useAccessRights from 'packages/hooks/useAccessRights';
import features from '~/configs/features';
import { isGradientColor } from '../../utils';
import { useEyeDropper } from './useEyeDropper';
import { CanvasDropper } from './CanvasDropper';

type Props = {
    value: Color;
    onChange: (color: Color) => void;
    disabled?: boolean;
};

export function EyeDropperButton({ value, onChange, disabled = false }: Props) {
    const { translate } = useTranslate();
    const { isPlatformAllowed } = useAccessRights();
    const { pickColor, isCanvasModeActive, onCanvasPick, cancelCanvasMode } = useEyeDropper(onChange);
    const tooltipLabel = translate('editor.sidebar.shots.color.eyedropper.button.tooltip');
    const buttonLabel = translate('editor.sidebar.shots.color.eyedropper.access');

    if (!isPlatformAllowed([features.EYE_DROPPER]) || isGradientColor(value)) {
        return null;
    }

    return (
        <>
            <Tooltip content={tooltipLabel} position="top-right">
                <Button
                    variant="clean"
                    icon={<IconColorPicker />}
                    isDisabled={disabled}
                    onClick={() => void pickColor()}
                    aria-label={buttonLabel}
                />
            </Tooltip>
            {isCanvasModeActive && <CanvasDropper onPick={onCanvasPick} onCancel={cancelCanvasMode} />}
        </>
    );
}
